import { ref, type Ref } from 'vue'

type Item = {
  id: number
  [key: string]: any
}

type DirtyItem = {
  id: number
  fields: string[]
  type: string | null
}

export const dirtyFieldMixin = (overrideDirtyItems: Ref<DirtyItem[]> = ref<DirtyItem[]>([])) => {
  const dirtyItems = overrideDirtyItems || ref<DirtyItem[]>([])
  const unSavedChanges = ref<boolean>(false)

  const findDirtyItem = (item: Item): DirtyItem | null => {
    return dirtyItems.value.find((dirtyItem: DirtyItem) => item.id === dirtyItem.id) || null
  }
  const addDirtyRow = (items: Item[], field: string, type = null) => {
    Object.values(items).forEach((item) => addDirty(item, field, type))
  }
  const addDirty = (item: Item, field: string, optionalKey = null) => {
    let dirtyItem = findDirtyItem(item)
    if (dirtyItem) {
      if (!dirtyItem.fields.includes(field)) {
        dirtyItem.fields.push(field)
      }
    } else {
      dirtyItem = { id: item.id, fields: [field], type: optionalKey }
      dirtyItems.value.push(dirtyItem)
    }
    unSavedChanges.value = true
  }
  const getDirtyClass = (item: Item, field: string) => {
    const dirtyItem = findDirtyItem(item)
    return dirtyItem?.fields.includes(field) ? 'border-bottom-orange' : 'border-bottom-blank'
  }
  const setUnsavedChanges = () => {
    unSavedChanges.value = true
  }
  return { unSavedChanges, dirtyItems, addDirty, addDirtyRow, getDirtyClass, setUnsavedChanges }
}
